<template>
  <div class="group-label-input group-label-input-address">
    <input 
      type="text" 
      v-model="shipmentAddress" 
      placeholder="Введите адрес"
      :class="getActive()" 
      v-bind:disabled="shipmentMethod == 'Самовывоз'"
    >
    <span v-show="searchingAddress" class="load-field-icon loader loader-for-field loader-dark-small"></span>
  </div> 

  <div v-show="showSearchAddrresses || showNewAddrressAdd" class="container-searching_address">
    <div v-if="showSearchAddrresses">
      <p 
        v-for="(address, index) in addressList" 
        :key="index" 
        @click="addShipmentAddress(address)"
      >
        {{ address }}
      </p>
    </div>
    <div v-else-if="showNewAddrressAdd" class="flex-address" @click="showFormAddAddress()">
      <p>Адрес не найден, укажите адрес вручную</p>
      <span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3 9.5C2.60218 9.5 2.22064 9.34196 1.93934 9.06066C1.65804 8.77936 1.5 8.39782 1.5 8C1.5 7.60218 1.65804 7.22064 1.93934 6.93934C2.22064 6.65804 2.60218 6.5 3 6.5C3.39782 6.5 3.77936 6.65804 4.06066 6.93934C4.34196 7.22064 4.5 7.60218 4.5 8C4.5 8.39782 4.34196 8.77936 4.06066 9.06066C3.77936 9.34196 3.39782 9.5 3 9.5ZM8 9.5C7.60218 9.5 7.22064 9.34196 6.93934 9.06066C6.65804 8.77936 6.5 8.39782 6.5 8C6.5 7.60218 6.65804 7.22064 6.93934 6.93934C7.22064 6.65804 7.60218 6.5 8 6.5C8.39782 6.5 8.77936 6.65804 9.06066 6.93934C9.34196 7.22064 9.5 7.60218 9.5 8C9.5 8.39782 9.34196 8.77936 9.06066 9.06066C8.77936 9.34196 8.39782 9.5 8 9.5ZM13 9.5C12.6022 9.5 12.2206 9.34196 11.9393 9.06066C11.658 8.77936 11.5 8.39782 11.5 8C11.5 7.60218 11.658 7.22064 11.9393 6.93934C12.2206 6.65804 12.6022 6.5 13 6.5C13.3978 6.5 13.7794 6.65804 14.0607 6.93934C14.342 7.22064 14.5 7.60218 14.5 8C14.5 8.39782 14.342 8.77936 14.0607 9.06066C13.7794 9.34196 13.3978 9.5 13 9.5Z" fill="#023276"/>
        </svg>
      </span>
    </div>
  </div>
</template>
  
<script>
  import GlobalRequest from "@/plugins/globalRequest";
  export default {
    name: 'ShipmentAddressField',

    emits: [
      'addShipmentAddress',
      'showFormAddAddressMethod',
      'editShipmentAddress',
      'haveNewAddressFalse'
    ],

    props: ["addressStr", "shipmentMethod", "incorrectAddress", "haveNewAddress", "selectedAddress"],

    data() {
      return {
        addressList: [],
        searchingAddress: false,
        showSearchAddrresses: false,
        showNewAddrressAdd: false,
        addressTimer: null,
        shipmentAddress: this.addressStr,
      };
    },

    watch: {
      'addressStr': {
        handler(newValue) {
          this.shipmentAddress = newValue
        },
        deep: true
      },

      'shipmentAddress': {
        async handler(newValue) {
          // this.checkServices()
          console.log(this.selectedAddress)
          console.log(this.shipmentAddress)

          if (newValue.length <= 2) {
            this.searchingAddress = false
            this.showSearchAddrresses = false
            this.showNewAddrressAdd = false
            this.$emit('haveNewAddressFalse')
          }

          // if(this.selectedAddress != this.shipmentAddress) {
          //   this.$emit('haveNewAddressFalse')
          // }

          if(this.selectedAddress != this.shipmentAddress) {
            clearTimeout(this.addressTimer); // Отменяем предыдущий таймер, если он есть

            this.addressTimer = setTimeout(async () => {
              if (newValue.length > 2) {
                this.searchingAddress = true
                // Запрос
                await this.getAddressList(newValue);

                if(this.addressList.length > 0) {
                  this.showSearchAddrresses = true
                  this.showNewAddrressAdd = false
                } 
                else {
                  this.showSearchAddrresses = false
                  this.showNewAddrressAdd = true
                }
              }
            }, 1000);
          } else if(this.selectedAddress == this.shipmentAddress) {
            this.showSearchAddrresses = false
            this.showNewAddrressAdd = false
          }

          this.$emit('editShipmentAddress', newValue)

        },
        deep: true
      },
    },

    methods: {

      getActive() {
        if(this.incorrectAddress) {
          return 'error-field'
        }
        if(this.shipmentMethod == 'Самовывоз') {
          this.shipmentAddress = ''
          return 'disableField'
        }
      },

      addShipmentAddress(address) {
        this.shipmentAddress = address
        this.$emit('addShipmentAddress', address)
        this.showSearchAddrresses = false
      },

      // Получение адреса
      async getAddressList(searchString) {
        let res = await GlobalRequest.fetchAddressData(searchString)
        console.log(res)
        if(res.success) {
          this.addressList = res.data.addresses.map((item) => {
            return item.address_details.postal_code ? `${item.address_details.postal_code}, ${item.full_name}` : item.full_name;
          });
        }
        else {
          console.log("Во время получения адресов произошла ошибка")
        }
        // Скрыть лоадер
        this.searchingAddress = false
        },

        showFormAddAddress() {
          console.log("1")
          this.$emit('showFormAddAddressMethod')
        },

      },

  };
  </script>